// Factories
import { BaseActionCreatorFactory } from "../../base/factories/BaseActionCreatorFactory";
/**
 * Factory class for Action creator in MetaOS app
 */
export class MetaOSAppActionCreatorFactory extends BaseActionCreatorFactory {
}
